export default {"src":"/_next/static/media/export.584e5932.gif","height":600,"width":1000,"blurWidth":0,"blurHeight":0};